import { wpFetch } from 'src/helpers/wpApiHandler';

const useDeleteRecruiter = async (bodyData) => {
  const response = await wpFetch(['recruiter'], {
    method: 'DELETE',
    body: bodyData,
  });

  return response;
};

export default useDeleteRecruiter;
